import React from 'react';

const iconClass = (name: string, extra = 'me-2') => `bi ${name} ${extra} an-icon-glyph`;

export const RoleIcon: React.FC = () => <i className={iconClass('bi-people')}></i>;
export const UserIcon: React.FC = () => <i className={iconClass('bi-person')}></i>;
export const SearchIcon: React.FC = () => <i className="bi bi-search" aria-hidden="true"></i>;
export const ClearIcon: React.FC = () => <i className="bi bi-x-lg" aria-hidden="true"></i>;
export const PlusIcon: React.FC = () => <i className={iconClass('bi-plus-lg', 'me-1')}></i>;
export const EditIcon: React.FC = () => <i className={iconClass('bi-pencil', 'text-primary')} style={{ cursor: 'pointer' }}></i>;
export const DeleteIcon: React.FC = () => <i className={iconClass('bi-trash', 'text-danger')} style={{ cursor: 'pointer' }}></i>;
export const AssignmentIcon: React.FC = () => <i className={iconClass('bi-clipboard-check')}></i>;
export const BusinessIcon: React.FC = () => <i className={iconClass('bi-building')}></i>;
export const LockIcon: React.FC = () => <i className={iconClass('bi-lock')}></i>;
export const ThresholdIcon: React.FC = () => <i className={iconClass('bi-clock')}></i>;
